module.exports = __webpack_public_path__ + "static/media/otherIcon.e9342211.svg";